module.exports = __webpack_public_path__ + "static/media/map-6.06a3ff26.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-6.png
// module id = 588
// module chunks = 23